import { alpha } from '@mui/material';

export const MuiInputAdornmentConfig = {
    styleOverrides: {
        positionStart: ({ theme }: { theme: any }) => {
            return {
                marginLeft: theme.spacing(1),
                marginRight: theme.spacing(-0.5),
                '.design-variant--secondary &': {
                    color: alpha(theme.palette.text.primary, 0.64),
                },
            };
        },
        positionEnd: ({ theme }: { theme: any }) => {
            return {
                marginLeft: theme.spacing(-0.5),
                marginRight: theme.spacing(1),
                '.design-variant--secondary &': {
                    color: alpha(theme.palette.text.primary, 0.64),
                },
            };
        },
    },
};
